import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';

interface PrivacyNoticeLinkProps {
  color?: string;
}

const PrivacyNoticeLink: React.FC<PrivacyNoticeLinkProps> = ({ color = 'primary.main' }) => (
  <Link
    component={RouterLink}
    to="/aviso-de-privacidad"
    sx={{
      color,
      fontSize: '0.75rem',
      fontWeight: 600,
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' }
    }}
  >
    Aviso de privacidad
  </Link>
);

export default PrivacyNoticeLink;
